import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported, deleteToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyB9G3EjE2A4Xv22qXAi2xj-nwJKH-JNk7I",
  authDomain: "wave-755af.firebaseapp.com",
  projectId: "wave-755af",
  storageBucket: "wave-755af.appspot.com",
  messagingSenderId: "610594970194",
  appId: "1:610594970194:web:2b3391f0b988d51e86dd8b",
  measurementId: "G-RKCG85MS6M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let messaging;

const initializeMessaging = async () => {
  try {
    if (await isSupported()) {
      messaging = getMessaging(app);
      console.log('Firebase Messaging initialized');
      return messaging;
    }
    console.warn('Firebase Messaging not supported in this environment');
    return null;
  } catch (error) {
    console.error('Error initializing Firebase Messaging:', error);
    return null;
  } 
};

// Initialize messaging immediately
messaging = await initializeMessaging();
export const requestForToken = async () => {
  try {
    console.log("messaging : " , messaging)
    if (!messaging) {
      console.warn('Messaging not available');
      return null;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    console.log("permission : " , permission)
    if (permission === 'granted') { 
      const vapidKey = "BLh1kV_MeXbQ0OKBMFB7aLYM_mkNH399reFyl5SMqQFiKML-VfBEWQyL5Ii4oHgWqOL3unLH4dBfI8b5TS25Y9U";  
      
      const currentToken = await getToken(messaging, { vapidKey });
      
      if (currentToken) {
        console.log('Current FCM token:', currentToken);
        return currentToken;
      } else {
        console.log('No registration token available.');
        return null;
      }
    } else {
      console.log('Notification permission denied.');
      return null;
    }
  } catch (err) {
    console.error('An error occurred while retrieving token:', err);
    return null;
  }
};

export const deleteFCMToken = async () => {
  try {
    if (!messaging) return;
    await deleteToken(messaging);
    console.log('Token deleted');
  } catch (error) {
    console.error('Error deleting token:', error);
  }
};

export const onMessageListener = () => {
  if (!messaging) {
    console.warn('Messaging not available for onMessageListener');
    return new Promise(() => {});
  }

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received:', payload);
      resolve(payload);
    });
  });
};

export { messaging };